export default __webpack_public_path__ + "static/media/Kickin.2218580c.png";